import { PlayerPageWrapper } from 'src/common/components/player-page-wrapper/player-page-wrapper';

type VideoDetailsPageProps = {
  params: {
    shortcode: string;
  };
};

const VideoDetailsPage = ({ params: { shortcode } }: VideoDetailsPageProps) => {
  return (
    <PlayerPageWrapper
      page={`/videos/${shortcode}/details`}
      title={`Video details for ${shortcode}`}
    />
  );
};

export default VideoDetailsPage;
